var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 7.875V21.875H32.375M42.875 21.875C42.875 24.6328 42.3318 27.3635 41.2765 29.9114C40.2211 32.4592 38.6743 34.7742 36.7242 36.7242C34.7742 38.6743 32.4592 40.2211 29.9114 41.2765C27.3635 42.3318 24.6328 42.875 21.875 42.875C19.1172 42.875 16.3865 42.3318 13.8386 41.2765C11.2908 40.2211 8.97579 38.6743 7.02576 36.7242C5.07573 34.7742 3.52888 32.4592 2.47353 29.9114C1.41818 27.3635 0.875 24.6328 0.875 21.875C0.875 16.3055 3.08749 10.964 7.02576 7.02576C10.964 3.08749 16.3055 0.875 21.875 0.875C27.4445 0.875 32.786 3.08749 36.7242 7.02576C40.6625 10.964 42.875 16.3055 42.875 21.875Z",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.d7b26aadf2eb1367ad23c0b9f7b7d496.svg";
export { ForwardRef as ReactComponent };